import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { FormFieldBaseComponent } from '../form-field-base/form-field-base.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'tt-radio-button-group',
    templateUrl: './radio-button-group.component.html',
    styleUrls: ['./radio-button-group.component.css'],
})
export class RadioButtonGroupComponent extends FormFieldBaseComponent implements AfterContentInit {
    @ContentChildren(RadioButtonComponent)
    public radioButtons?: QueryList<RadioButtonComponent>;

    @Input()
    ttModel = '';

    @Output()
    ttModelChange = new EventEmitter<string>();

    /**
     * @default false
     */
    @Input()
    set ttAutoSelectFirst(value: BooleanInput) {
        this._autoSelectFirst = coerceBooleanProperty(value);
    }
    get ttAutoSelectFirst(): boolean {
        return this._autoSelectFirst;
    }
    private _autoSelectFirst = false;

    /**
     * Sets the given id as the selected id and emits a selected id change event.
     *
     * @emits `ttSelectedIdChange` containing the new id in the event.
     */
    private selectId(id: string) {
        if (id !== this.ttModel) {
            this.ttModel = id;
            this.ttModelChange.emit(this.ttModel);
        }
    }

    private async getLastSelectedId() {
        if (!this.ttRememberId) return;

        try {
            // this.radioButtons?.forEach((radio) => (radio.ttSkeleton = true));
            const lastId = (await this.remember.getLastStatus(this.ttRememberId))?.[0]?.variablevalue;

            if (!!lastId) {
                this.selectId(lastId);
            }
        } catch (err) {
            console.error(err);
        }
    }

    private hasSelectedTab() {
        const selectedRadio = this.radioButtons?.find((radio) => !radio.ttDisabled && radio.ttValue === this.ttModel);

        return !!selectedRadio;
    }

    private selectFirstAvailableId() {
        let firstAvailableId: string = '';

        if (!firstAvailableId && !!this.radioButtons && this.radioButtons.length > 0) {
            firstAvailableId = this.radioButtons.find((tab) => tab.ttDisabled !== true)?.ttValue || '';
        }

        if (!!firstAvailableId) {
            this.selectId(firstAvailableId);
        }
    }

    override async ngAfterContentInit() {
        super.ngAfterContentInit();

        this.radioButtons?.changes.subscribe({
            next: (radios) => {
                if (radios instanceof QueryList) {
                    this.configureRadios(radios);
                }
            },
        });

        if (this.radioButtons) {
            this.configureRadios(this.radioButtons);
        }

        if (!this.ttOnlyRemember && !!this.ttRememberId) {
            await this.getLastSelectedId();
        }

        if (this.ttAutoSelectFirst && !this.hasSelectedTab()) {
            this.selectFirstAvailableId();
        }
    }

    private configureRadios(radios: QueryList<RadioButtonComponent>) {
        radios.forEach((radio: RadioButtonComponent) => {
            radio.name = this.ttLabel;
            radio.model = this.ttModel;

            if (!radio.modelChange.observed) {
                radio.modelChange.subscribe({
                    next: (value: string) => {
                        this.ttModel = value;
                        this.ttModelChange.emit(value);
                    },
                });
            }
        });
    }
}
